// generic API class with post, get, put, delete methods. Constructor takes a base url. The base url shouldn't actually hit any endpoints, just return promises with some sort of test result
class API {
    originalUrl: string;
    baseUrl: string;
    adapter: ApiAdapter;
    constructor(baseUrl: string, adapter: string) {
        this.baseUrl = baseUrl;
        this.originalUrl = baseUrl;
        this.adapter = this.adapters[adapter];
    }

    get adapters() {
        return {
            mock: new MockAdapter(),
            fetch: new FetchAdapter()
        };
    }

    get(url: string, options?: any) {
        return this.adapter.get(this.baseUrl + url, options);
    }

    post(url: string, data: any) {
        return this.adapter.post(this.baseUrl + url, data);
    }

    put(url: string, data: any) {
        return this.adapter.put(this.baseUrl + url, data);
    }

    delete(url: string) {
        return this.adapter.delete(this.baseUrl + url);
    }
}

class FetchAdapter implements ApiAdapter {
    private abortController: AbortController;
    private responseFetching: Map<string, Boolean> = new Map();
    constructor() {
        this.abortController = new AbortController();
    }
    async get(url: string, options?: any) {
        if( this.responseFetching.has(url) && this.responseFetching.get(url) ) {
            this.abortController.abort('New request made');
            this.abortController = new AbortController();
        }
        this.responseFetching.set(url, true);
        const opts = options ?? {};
        opts.signal = this.abortController.signal;
       const response = await fetch(url, {
            method: "GET",
            ...opts
        });


        this.responseFetching.set(url, false);
        return response;
    }

    post(url: string, data: any) {
        return fetch(url, {
            method: "POST",
            body: JSON.stringify(data)
        });
    }

    put(url: string, data: any) {
        return fetch(url, {
            method: "PUT",
            body: JSON.stringify(data)
        });
    }

    delete(url: string) {
        return fetch(url, {
            method: "DELETE"
        });
    }
}

class MockAdapter implements ApiAdapter {

    get(url: string, mockedDefinition?: any) {
        const mockedData: any = mockedDefinition ?? { data: "mock get data" };
        return new Promise((resolve, reject) => {
            resolve({
                json: () =>
                    new Promise((resolve, reject) => {
                        resolve(mockedData);
                    })
            });
        });
    }

    post(url: string, data: any) {
        return Promise.resolve({ data: "mock post data" });
    }

    put(url: string, data: any) {
        return Promise.resolve({ data: "mock put data" });
    }

    delete(url: string) {
        return Promise.resolve({ data: "mock delete data" });
    }
}

interface ApiAdapter {
    get(url: string, options?: any): Promise<any>;
    post(url: string, data: any): Promise<any>;
    put(url: string, data: any): Promise<any>;
    delete(url: string): Promise<any>;
}

export default API;
